import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const FeatureService = {
  /**
   * Get Screen data
   *
   * */
  async getFeatureData(username) {
    const requestFeatureData = {
      url: "api/ApplicationUserToPermission",
      top: "500",
      filter: `(ApplicationUserCode eq '${username}' and Inactive eq 'N') and (ReadPermission eq 'Y' or WritePermission eq 'Y')`,
    };

    return await ApiService.oDataGet(requestFeatureData);
  },

  async getFeatureManagementData(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },

  async saveFeatureManagement(feature) {
    var url = "api/ApplicationFeatureManagement";
    return await ApiService.post(url, feature);
  },
};

export default FeatureService;

export { FeatureService };
